const platform = require('platform');

import React, { Component } from 'react';
import { Link } from 'react-router';

import routeConfig from '../../config/route.json';

import '../../css/menu.css';

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = this.props;

    // console.log(this.props.lang);
    // console.log(routeConfig.gallery[this.props.lang].name);
    // this.pageChange = this.pageChange.bind(this);

  }

  componentDidMount() {
    console.log("Header mount")
    this.changePositioning();
    window.addEventListener('resize', this.changePositioning);
  }

  componentWillUpdate(){
    console.log("Header update")
    this.changePositioning();
    console.log(this.state);
  }

  componentWillUnmount() {}

  changePositioning() {

    // let ratio = 0.75;
    // let windowWidth = window.innerWidth;
    let windowWidth = 1100;


    let oneLineTop = windowWidth * 45/1100 + 'px';
    let oneLineHeight = windowWidth * 0.011 + 'px';

    let twoLineTop = windowWidth * 0.0315 + 'px';
    let twoLineHeight = windowWidth * 0.024 + 'px';
    

    // let logoTop = windowWidth * 0.016 + 'px';
    let logoTop = '';
    let logoLeft = '';
    let logoWidth = '';
    let logoTopPerc = 8/1300;
    let logoLeftPerc = 0.361538462;
    let logoWidthPerc = 0.153846154;

    if (window.innerWidth < 1300) {
      logoTop = 1300 * logoTopPerc + 'px';
      logoLeft = 1300 * logoLeftPerc + 'px';
      logoWidth = 1300 * logoWidthPerc + 'px';
    } else {
      logoTop = window.innerWidth * logoTopPerc + 'px';
      logoLeft = window.innerWidth * logoLeftPerc + 'px';
      logoWidth = window.innerWidth * logoWidthPerc + 'px';
    }

    // console.log(logoTop)
    // console.log(logoLeft)

    // if (this == window) {
      // let lang = window.location.hash.split('/')[1];
    let pathArr = window.location.pathname.split('/');
    let lang = pathArr[2] === '' ? 'en' : pathArr[2];
    if (lang !== 'en') {
      twoLineTop = oneLineTop;
      twoLineHeight = oneLineHeight;
    }
      // console.log('if: '+lang)
    // } else {
    //   if (this.state.lang !== 'en') {
    //     twoLineTop = oneLineTop;
    //     twoLineHeight = oneLineHeight;
    //   }
    //   console.log('else: '+this.state.lang)
    // }

    document.getElementById(routeConfig.gallery.id).style.top = oneLineTop;
    document.getElementById(routeConfig.gallery.id).style.height = oneLineHeight;

    document.getElementById(routeConfig.announcement.id).style.top = oneLineTop;
    document.getElementById(routeConfig.announcement.id).style.height = oneLineHeight;

    document.getElementById(routeConfig.salesBrochure.id).style.top = oneLineTop;
    document.getElementById(routeConfig.salesBrochure.id).style.height = oneLineHeight;

    document.getElementById(routeConfig.priceList.id).style.top = oneLineTop;
    document.getElementById(routeConfig.priceList.id).style.height = oneLineHeight;

      document.getElementById(routeConfig.home.id).style.top = logoTop;

    document.getElementById(routeConfig.salesArrangements.id).style.top = twoLineTop;
    document.getElementById(routeConfig.salesArrangements.id).style.height = twoLineHeight;

    document.getElementById(routeConfig.registerOfTransactions.id).style.top = twoLineTop;
    document.getElementById(routeConfig.registerOfTransactions.id).style.height = twoLineHeight;

    document.getElementById(routeConfig.deedOfMutualCovenant.id).style.top = twoLineTop;
    document.getElementById(routeConfig.deedOfMutualCovenant.id).style.height = twoLineHeight;

    document.getElementById(routeConfig.aerialPhotograph.id).style.top = twoLineTop;
    document.getElementById(routeConfig.aerialPhotograph.id).style.height = twoLineHeight;

    document.getElementById(routeConfig.tenderDocuments.id).style.top = twoLineTop;
    document.getElementById(routeConfig.tenderDocuments.id).style.height = twoLineHeight;

    
    // console.log("Header: " + oneLineTop);
    // console.log("Header: " + oneLineHeight);
    // console.log("Header: " + twoLineTop);
    // console.log("Header: " + twoLineHeight);
  }

  render() {
    console.log(platform.os.family);
    console.log(platform.os.family.indexOf('Windows'));
    let fontSizeCss = 'font-size: 15px';
    if ( platform.os.family.indexOf('Windows') > -1) {
      fontSizeCss = 'font-size: 13px';
    }

    return <div id='App-header' className='App-header'>
      <div className='menu'>

        <div className='menu-item' id={routeConfig.home.id} style={{
          left: this.props.lang === 'en' ? '-6.5%' : '-4.5%',
          width: '17%',
        }}>
          <p>
            <Link to={routeConfig.home[this.props.lang].url} id='logo'>
              <img src={routeConfig.home.imageUrl} style={{width: '110%'}}/>
            </Link>
          </p>
        </div>

        <p className='menu-item' id={routeConfig.salesBrochure.id} style={{
          'left': this.props.lang === 'en' ? '10.0%' : '11.8%',
          'width': '14.5%',
        }}>
          <Link to={routeConfig.salesBrochure[this.props.lang].url} dangerouslySetInnerHTML={{__html: "<span style='" + fontSizeCss + "'>" + routeConfig.salesBrochure[this.props.lang].name + "</span>" }}>
            
          </Link>
        </p>
        <p className='menu-item' id={routeConfig.priceList.id} style={{
          'left': this.props.lang === 'en' ? '21.3%' : '21.3%',
          'width': '130px',
        }}>
          <Link to={routeConfig.priceList[this.props.lang].url} dangerouslySetInnerHTML={{__html: "<span style='" + fontSizeCss + "'>" + routeConfig.priceList[this.props.lang].name + "</span>" }}>
            
          </Link>
        </p>
        <p className='menu-item' id={routeConfig.salesArrangements.id} style={{
          'left': '31.4%',
          'width': '10.4%',
        }}>
          <Link to={routeConfig.salesArrangements[this.props.lang].url} dangerouslySetInnerHTML={{__html: "<span style='" + fontSizeCss + "'>" + routeConfig.salesArrangements[this.props.lang].name + "</span>" }}>
            
          </Link>
        </p>
        <p className='menu-item' id={routeConfig.registerOfTransactions.id} style={{
          'left': '42.2%',
          'width': '115px',
        }}>
          <Link to={routeConfig.registerOfTransactions[this.props.lang].url} dangerouslySetInnerHTML={{__html: "<span style='" + fontSizeCss + "'>" + routeConfig.registerOfTransactions[this.props.lang].name + "</span>" }}>
            
          </Link>
        </p>

        <p className='menu-item' id={routeConfig.deedOfMutualCovenant.id} style={{
          'left': '52.2%',
          'width': '141px',
        }}>
          <Link to={routeConfig.deedOfMutualCovenant[this.props.lang].url} dangerouslySetInnerHTML={{__html: "<span style='" + fontSizeCss + "'>" + routeConfig.deedOfMutualCovenant[this.props.lang].name + "</span>" }}>
            
          </Link>
        </p>
        <p className='menu-item' id={routeConfig.aerialPhotograph.id} style={{
          'left': '65.3%',
          'width': '90px',
        }}>
          <Link to={routeConfig.aerialPhotograph[this.props.lang].url} dangerouslySetInnerHTML={{__html: "<span style='" + fontSizeCss + "'>" + routeConfig.aerialPhotograph[this.props.lang].name + "</span>" }}>
            
          </Link>
        </p>
        <p className='menu-item' id={routeConfig.announcement.id} style={{
          'left': '74.6%',
          'width': '9.5%',
        }}>
          <Link to={routeConfig.announcement[this.props.lang].url} dangerouslySetInnerHTML={{__html: "<span style='" + fontSizeCss + "'>" + routeConfig.announcement[this.props.lang].name + "</span>" }}>
            
          </Link>
        </p>
        <p className='menu-item' id={routeConfig.gallery.id} style={{
          'left': '85.2%',
          'width': '5.9%',
        }}>
          <Link to={routeConfig.gallery[this.props.lang].url} dangerouslySetInnerHTML={{__html: "<span style='" + fontSizeCss + "'>" + routeConfig.gallery[this.props.lang].name + "</span>" }}>
            
          </Link>
        </p>
        <p className='menu-item' id={routeConfig.tenderDocuments.id} style={{
          'left': '91.6%',
          'width': '6.5%',
        }}>
          <Link to={routeConfig.tenderDocuments[this.props.lang].url} dangerouslySetInnerHTML={{__html: "<span style='" + fontSizeCss + "'>" + routeConfig.tenderDocuments[this.props.lang].name + "</span>" }}>
            
          </Link>
        </p>

      </div>
    </div>
  }
}


export default Header;



// WEBPACK FOOTER //
// ./src/desktop/layout/Header.js